@if (showResetButton) {
  <div style="position:fixed;top:12px;right:34px;z-index:1100;">
    <button (click)="onResetApp()" title="Reset App (Clear Cache & Reload)" style="background:#fff;border:1px solid #1976d2;color:#1976d2;padding:0.5em 1em;border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,0.10);font-weight:600;cursor:pointer;display:flex;align-items:center;gap:0.5em;">
      <span style="font-size:1.2em;">&#x21bb;</span> Reset App
    </button>
  </div>
}
<app-loading-spinner></app-loading-spinner>

<!--
<div *ngIf="showUpdateAvailable" style="position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:1000;background:#1976d2;color:white;padding:1em 2em;text-align:center;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.15);min-width:280px;max-width:90vw;">
  A new version of Apruv is available.
  <button (click)="onReloadForUpdate()" style="margin-left:1em;padding:0.5em 1em;background:white;color:#1976d2;border:none;border-radius:4px;cursor:pointer;font-weight:600;">Reload</button>
</div>
-->

<router-outlet></router-outlet>
